<template>
      <div no-body class="lku-itemRcp"> 
      <b-form-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-form-row>
      <b-form-row v-else>
         <b-col lg="11">
            <b-row v-if="(lockItems == 0)" no-gutters>
              <b-col lg="12">
                <b-input-group>
                    <b-input-group-prepend><span class="pt-2 mr-2">Filter</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.partnumber" placeholder="Item Code" value="" @keyup.13.native="refresh()"></b-form-input>
                    <b-form-input v-model="tblData.itemname" placeholder="Item Name" value="" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
                    <b-input-group-append>
                        <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i>Show</b-button>
                    </b-input-group-append>
                    <b-input-group-append>
                      <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button>
                    </b-input-group-append>
                </b-input-group>                    
              </b-col>
            </b-row>     
            <b-row v-else>
              <b-col md="10">
                  <b-input-group size="sm">
                    <b-input-group-prepend><span class="pt-2 mr-2">Filter</span></b-input-group-prepend>
                      <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
            </b-row>                 
          </b-col>
      </b-form-row>
      <b-table
          class="m-0"
          ref="tblItemRcp"
          responsive striped hover small
          style="font-size:smaller;" 
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"                
          @row-clicked="selectItem"
          show-empty
        >
          <template v-slot:cell(jasa)="data">
            <span v-if="(data.item.jasa==1)">Service</span>
            <span v-else>Material</span>
          </template>
        <template v-slot:cell(recivDate)="data">
          <span v-if="(data.item.recivDate)">{{data.item.recivDate|moment("DD MMM YYYY")}}</span>
        </template>
        <template v-slot:cell(expirDate)="data">
          <span v-if="(data.item.expirDate)">{{data.item.expirDate|moment("DD MMM YYYY")}}</span>
        </template>
        <template v-slot:cell(qtyAvail)="data">
          {{data.item.qtyAvail}} {{data.item.invunitom}}
        </template>

          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
          </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-itemRcp {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import moment from 'moment';
import inv from "../../apis/logistic_inv_in";

export default {
  data() {
    return {
      fields: [
          {
            key: "recivDate",
            thStyle: "width:90px",
            label: "Receiving Date",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item Code",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "typeseries",
            thStyle: "width:90px",
            label: "Type Series",
            sortable: true
          },
          {
            key: "serialNum",
            thStyle: "width:90px",
            label: "Serial Number",
            sortable: true
          },
          {
            key: "qtyAvail",
            label: "Qty Available",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "qtyReserved",
            label: "Reserved",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "expirDate",
            thStyle: "width:90px",
            label: "Expired Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            thStyle: "width:180px",
            label: "Supplier",
            sortable: true
          },
          {
            key: "purcOrderNo",
            label: "PO#",
            thStyle: "width:90px",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'recivDate',
        sortDesc: false,
        outstand:'1',
        idStore:''
      },
      lkuLoading:false,
      updatetable:false,
      filter: null,
      filterOn: [],   
    };
  },
  computed: {
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
    lockItems() {
      return (this.arrItem || []).length;
    },
  },
  watch: {
    pagechange: function(newval) {
      if (this.lockItems == 0) {
          this.tblData.page=newval;
          this.data();
      }
    },   
    limitchange: function(newval) {
      if (this.lockItems == 0) {
          this.data();
      }
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   

  },  
  props: ["idStore", "arrItem","issuedItems","formdata","typeseries"],
  created: async function() {
      this.tblData.idStore=this.idStore;
      this.tblData.arrItem=this.arrItem;
      this.tblData.typeseries=this.typeseries ||'';
      // if (this.custcode) {
      //   if (this.formdata.items)
      //   {
      //     if (this.formdata.items[0].custcode!==this.custcode) {
      //       this.data();
      //     } else {
      //       for (var key in this.formdata) {
      //           this.tblData[key] = this.formdata[key];
      //       }
      //     }
      //   } else {
      //     this.data();
      //   }
      // } else {
      //   if (this.formdata.items)
      //   {
      //       for (var key in this.formdata) {
      //           this.tblData[key] = this.formdata[key];
      //       }
      //   }
      // }
      if ((this.arrItem || []).length > 0) {
        this.data();
      } 
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
      this.lkuLoading = false;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const issuedItems = this.issuedItems || [];
      const items= await inv.list(this.tblData);  
      // if (this.lockItems == 0) {
      //   const items= await inv.list(this.tblData);  
      // } else {
      //   const items= await inv.listByItemsNo(this.arrItem);  
      // }  
      this.lkuLoading = false;
      // return items;      
      if(issuedItems.filter(x=>x.itemReciKey).length>0){
        // console.log('issuedItems',issuedItems)
        items.map(item=>{
          const sumIssued = issuedItems.filter(x=>x.itemReciKey==item.itemReciKey).reduce((accumulator=0, dt) => {
            return accumulator+=parseInt(dt.qtyIssued)
          }, 0);
          item.qtyAvail -= sumIssued
        });

      }
      this.tblData.items=items;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.partnumber=  '';
        this.tblData.nmcategory=  '';
        this.tblData.inven_catid=  '';
        this.refresh();
    },    
    refresh() {
      // this.$refs.tblItemRcp.refresh();
      this.data();
    }
  }
};
</script>
